export default {
  en: {
    title: 'Branches',
    subtitle: 'List of branches',
    enrollPoc: 'Enroll POC',
    instructions: 'Enter manually the POC id or scan the QR showed in the screen of the POC',
    created: 'The branch was created successfully',
    edited: 'The branch {branch} was edited successfully',
    filters: {
      text: 'Filter branches by name or id',
    },
    form: {
      label: {
        label: 'Name',
        help: 'Name of the branch',
      },
      name: {
        label: 'ID',
        help: 'ID of the branch',
      },
      segments: {
        help: 'List of segments assigned to the branch',
      },
      integrationId: {
        label: 'Integration ID',
        help: 'ID to use with integration',
      },
      address: {
        label: 'Address',
        help: 'Address of the branch',
      },
    },
    formPoc: {
      poc: {
        label: 'POC id',
        help: 'POC enrollment ID',
      },
      label: {
        label: 'Name',
        help: 'Name of the POC like A1',
      },
      internalId: {
        label: 'Internal Id',
        help: 'POC internal ID',
      },
      integrationId: {
        label: 'Integration Id',
        help: 'POC ID for integration',
      },
      latestConnection: {
        label: 'Latest connection',
      },
      enrollDay: {
        label: 'Enroll day',
      },
      browserName: {
        label: 'Browser name',
      },
      browserVersion: {
        label: 'Browser version',
      },
      osName: {
        label: 'OS name',
      },
      osVersion: {
        label: 'OS version',
      },
      deviceType: {
        label: 'Device type',
      },
      ip: {
        label: 'IP address',
      },
      statusConnection: {
        label: 'Status connection',
      },
      steps: {
        '1': 'Scan',
        '2': 'Setup',
      },
      acceptTerms: 'I\'m sure want to enroll the POC to the branch',
      reminder: 'Remember you will be able to choose what value you want to use in the displays integration through webhooks',
      deviceInfoTitle: 'Device details',
      warningDeleteConnection: 'Cannot unroll or edit the POC if is connected, please disconnect before deleting',
    },
    notification: {
      success: 'The POC was enrolled successfully to the branch',
      sucessEdit: 'POC edited successfully',
      successDeleted: 'POC unrolled successfully',
    },
    pocDetailsModal: {
      title: 'Details of the POC',
      unroll: {
        title: 'Confirm you want to unroll the POC?',
      },
    },
  },
  es: {
    title: 'Sucursales',
    subtitle: 'Listado de sucursales',
    enrollPoc: 'Enrolar POC',
    instructions: 'Ingresa el ID del POC manualmente o escanea el QR que se muestra en la pantalla del POC',
    created: 'La sucursal ha sido creada correctamente',
    edited: 'La sucursal {branch} ha sido editada correctamente',
    filters: {
      text: 'Filtra sucursales por nombre o id',
    },
    form: {
      label: {
        label: 'Nombre',
        help: 'Nombre de la sucursal',
      },
      name: {
        label: 'ID',
        help: 'ID de la sucursal',
      },
      segments: {
        help: 'Listado de segmentos asignados a la sucursal',
      },
      integrationId: {
        label: 'Id de integración',
        help: 'ID para usar en integraciones',
      },
      address: {
        label: 'Dirección',
        help: 'Dirección de la sucursal',
      },
    },
    formPoc: {
      poc: {
        label: 'POC id',
        help: 'Id POC a enrolar',
      },
      label: {
        label: 'Nombre',
        help: 'Nombre del POC como A1',
      },
      internalId: {
        label: 'Id interno',
        help: 'Id interno del POC',
      },
      integrationId: {
        label: 'Id del integración',
        help: 'Id de integración del POC',
      },
      latestConnection: {
        label: 'Última conexión',
      },
      enrollDay: {
        label: 'Día de enrolamiento',
      },
      browserName: {
        label: 'Nombre navegador',
      },
      browserVersion: {
        label: 'Versión navegador',
      },
      osName: {
        label: 'Nombre sistema operativo',
      },
      osVersion: {
        label: 'Versión sistema operativo',
      },
      deviceType: {
        label: 'Tipo dispositivo',
      },
      ip: {
        label: 'Dirección IP',
      },
      statusConnection: {
        label: 'Estado de conexión',
      },
      steps: {
        '1': 'Escanear',
        '2': 'Configurar',
      },
      acceptTerms: 'Estoy seguro que enrolaré el POC a la sucursal',
      reminder: 'Recuerda que podrás elegir qué valor quieres utilizar en la integración con tus pantallas mediante webhooks',
      deviceInfoTitle: 'Detalles del dispositivo',
      warningDeleteConnection: 'No se puede desenrollar o editar el POC si está conectado, desconéctelo antes de eliminarlo',
    },
    notification: {
      success: 'El POC ha sido enrolado correctamente a la sucursal',
      successEdit: 'POC editado exitosamente',
      successDeleted: 'POC desenrolado exitosamente',
    },
    pocDetailsModal: {
      title: 'Detalles del POC',
      unroll: {
        title: 'Deseas confirmar la acción de desenrolar el POC?',
      },
    },
  },
  fr: {
    title: 'Branches',
    subtitle: 'Liste des branches',
    enrollPoc: 'Enrôler POC',
    instructions: 'Entrez manuellement l\'ID du POC ou scannez le QR affiché sur l\'écran du POC',
    created: 'La branche a été créée avec succès',
    edited: 'La branche {branch} a été modifiée avec succès',
    filters: {
      text: 'Filtrer les branches par nom ou ID',
    },
    form: {
      label: {
        label: 'Nom',
        help: 'Nom de la branche',
      },
      name: {
        label: 'ID',
        help: 'ID de la branche',
      },
      segments: {
        help: 'Liste des segments assignés à la branche',
      },
      integrationId: {
        label: 'ID d\'intégration',
        help: 'ID à utiliser avec l\'intégration',
      },
      address: {
        label: 'Adresse',
        help: 'Adresse de la branche',
      },
    },
    formPoc: {
      poc: {
        label: 'ID POC',
        help: 'ID d\'enrôlement du POC',
      },
      label: {
        label: 'Nom',
        help: 'Nom du POC, comme A1',
      },
      internalId: {
        label: 'ID interne',
        help: 'ID interne du POC',
      },
      integrationId: {
        label: 'ID d\'intégration',
        help: 'ID du POC pour l\'intégration',
      },
      latestConnection: {
        label: 'Dernière connexion',
      },
      enrollDay: {
        label: 'Jour d\'enrôlement',
      },
      browserName: {
        label: 'Nom du navigateur',
      },
      browserVersion: {
        label: 'Version du navigateur',
      },
      osName: {
        label: 'Nom du système d\'exploitation',
      },
      osVersion: {
        label: 'Version du système d\'exploitation',
      },
      deviceType: {
        label: 'Type de périphérique',
      },
      ip: {
        label: 'Adresse IP',
      },
      statusConnection: {
        label: 'État de la connexion',
      },
      steps: {
        '1': 'Scanner',
        '2': 'Configurer',
      },
      acceptTerms: 'Je suis sûr de vouloir enrôler le POC dans la branche',
      reminder: 'Rappelez-vous que vous pourrez choisir la valeur que vous souhaitez utiliser dans l\'intégration des affichages via des webhooks',
      deviceInfoTitle: 'Détails du périphérique',
      warningDeleteConnection: 'Impossible de désenrôler ou de modifier le POC s\'il est connecté, veuillez vous déconnecter avant de supprimer',
    },
    notification: {
      success: 'Le POC a été enrôlé avec succès dans la branche',
      sucessEdit: 'POC modifié avec succès',
      successDeleted: 'POC désenrôlé avec succès',
    },
    pocDetailsModal: {
      title: 'Détails du POC',
      unroll: {
        title: 'Confirmez-vous vouloir désenrôler le POC ?',
      },
    },
}

}
